module.exports = __webpack_public_path__ + "assets/img/1429.b42b052c.svg";